var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-activity"},[_c('p',{class:_vm.isShop ? 'shop-tag activity' : 'activity'},[(_vm.isShop)?_c('i',{staticClass:"icon-outlined_store"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }